import { createAction, props } from '@ngrx/store';
import { Dossier } from '@models/dossier/dossier';
import { Role } from 'app/modules/shared-area/ducks/user/models/role';
import {
  ErfassungRef,
  ErfassungRefWithReason,
  ReEdit,
  RequestForApproval,
  RevertAllChanges,
  TakeErfassung,
} from 'app/models/erfassungRef';
import { LoadSubstance } from 'app/modules/dossier-area/ducks/models/loadSubstance';
import { RenderState, SearchState, ThesaurusMode } from './dossier.state';
import { UserItem } from 'app/core/services/api-client';

// Effects actions
export const dossierLoeschenBeantragen = createAction(
  '[Dossier] Dossier Loeschen Beantragen',
  props<{ id: string, message: string | undefined, bearbeiterUid?: string | undefined, bearbeiter?: string | undefined }>()
);

export const dossierLoeschenBeantragenSuccess = createAction(
  '[Dossier] Dossier Loeschen Beantragen Success'
);

export const dossierLoeschenBeantragenError = createAction(
  '[Dossier - Effect] Dossier Loeschen Beantragen (Error)',
  props<{ error: string }>()
);

export const revertAllChanges = createAction(
  '[Dossier] Revert all changes',
  props<{ revertAllChanges: RevertAllChanges }>()
);

export const revertAllChangesError = createAction(
  '[Dossier] Revert all changes Error'
);

export const revertAllChangesSuccess = createAction(
  '[Dossier] Revert all changes Success',
  props<{ revertAllChanges: RevertAllChanges }>()
);

export const deleteErfassung = createAction(
  '[Dossier] Delete Erfassung',
  props<{ erfassungRef: ErfassungRef }>()
);

export const deleteErfassungError = createAction(
  '[Dossier] Delete Erfassung Error'
);

export const stoffFreigabeprozessStartenEffect = createAction(
  '[Dossier Effect] Stoff Freigabeprozess starten',
  props<{ erfassungId: number, message: string | undefined, bearbeiterUid?: string | undefined, bearbeiter?: string | undefined }>()
);

export const stoffFreigabeprozessStartenSuccessEffect = createAction(
  '[Dossier Effect] Stoff Freigabeprozess starten Success'
);

export const stoffFreigabeprozessStartenErrorEffect = createAction(
  '[Dossier Effect] Stoff Freigabeprozess starten Error',
  props<{ error: string }>()
);

export const confirmAsAdminEffect = createAction(
  '[Dossier - Effect] Confirm as admin',
  props<{ erfassungRef: ErfassungRef }>()
);

export const confirmAsAdminError = createAction(
  '[Dossier] Confirm as admin (Error)'
);

export const confirmAsLecturerEffect = createAction(
  '[Dossier - Effect] Confirm as lecturer',
  props<{ erfassungRef: ErfassungRef }>()
);

export const confirmAsLecturerError = createAction(
  '[Dossier] Confirm as lecturer (Error)'
);

export const confirmMergeEffect = createAction(
  '[Dossier - Effect] Confirm merge',
  props<{ erfassungRef: ErfassungRef }>()
);

export const confirmMergeError = createAction(
  '[Dossier] Confirm merge (Error)'
);

export const rejectAsAdminEffect = createAction(
  '[Dossier] Reject as admin',
  props<{ erfassungRefWithReason: ErfassungRefWithReason }>()
);

export const rejectAsAdminError = createAction(
  '[Dossier] Reject as admin (Error)'
);

export const rejectAsLecturerEffect = createAction(
  '[Dossier] Reject as lecturer',
  props<{ erfassungRefWithReason: ErfassungRefWithReason }>()
);

export const rejectAsLecturerError = createAction(
  '[Dossier] Reject as lecturer (Error)'
);

export const rejectMergeEffect = createAction(
  '[Dossier] Reject merge',
  props<{ erfassungRefWithReason: ErfassungRefWithReason }>()
);

export const rejectMergeError = createAction(
  '[Dossier] Reject merge (Error)'
);

export const reEditDossierEffect = createAction(
  '[Dossier - Effect] Bearbeite Erfassung',
  props<{ reEdit: ReEdit }>()
);

export const startSearchEffect = createAction(
  '[Dossier - Effect] Starte die Suche im Dossier',
  props<{ search: string; isWholeWord: boolean; isIgnoreCase: boolean }>()
);

// State management actions
export const loadErfassung = createAction(
  '[Dossier] Load Erfassung',
  props<{ erfassungRef: ErfassungRef }>()
);

export const loadErfassungSuccess = createAction(
  '[Dossier] Load Erfassung Success',
  props<{ dossier: Dossier }>()
);

export const loadErfassungError = createAction(
  '[Dossier] Load Erfassung Error'
);

export const loadSubstance = createAction(
  '[Dossier] Load Dossier',
  props<{ loadSubstance: LoadSubstance }>()
);

export const loadSubstanceSuccess = createAction(
  '[Dossier] Load Dossier Success',
  props<{ dossier: Dossier }>()
);

export const loadSubstanceError = createAction(
  '[Dossier] Load Dossier Error'
);

export const showSmallLoadingSpinner = createAction(
  '[Dossier] Toggle small loading spinner',
  props<{ isInProgress: boolean }>()
);

export const partialUpdateDossier = createAction(
  '[Dossier] Partial Update Dossier',
  props<{ updatedDossier: Dossier }>()
);

export const clearRenderState = createAction(
  '[Dossier] Clear dossier render state'
);

export const setRoleContext = createAction(
  '[Dossier] Set the role for the current dossier (lector / admin)',
  props<{ role: Role | null }>()
);

export const reEditDossier = createAction(
  '[Dossier] Re-Edit Dossier'
);

export const reEditDossierSuccess = createAction(
  '[Dossier] Re-Edit Dossier (Success)',
  props<{ reEdit: ReEdit }>()
);

export const reEditDossierError = createAction(
  '[Dossier] Re-Edit Dossier (Error)'
);

export const withdrawErfassung = createAction(
  '[Dossier] Erfassung zurückziehen',
  props<{ erfassungRef: ErfassungRef }>()
);

export const takeErfassung = createAction(
  '[Dossier] Übernehme Erfassung',
  props<{ takeErfassung: TakeErfassung }>()
);

export const takeErfassungSuccess = createAction(
  '[Dossier] Übernehme Erfassung (Success)',
  props<{ takeErfassung: TakeErfassung }>()
);

export const takeErfassungError = createAction(
  '[Dossier] Übernehme Erfassung (Error)'
);

export const setRenderState = createAction(
  '[Dossier] Setze Renderstatus der Dossier Panels',
  props<{ panelId: string; renderState: RenderState }>()
);

export const setSearchState = createAction(
  '[Dossier] Setze die Daten, welche zur Suche im Dossier benötig werden',
  props<{ search: string; hits: Set<string>; isWholeWord: boolean; isIgnoreCase: boolean; state: SearchState }>()
);

export const setSearchStateState = createAction(
  '[Dossier] Setze den Status der Dossiersuche',
  props<{ searchState: SearchState }>()
);

export const gotoSearchResult = createAction(
  '[Dossier] Setze das nächste/verherige Suchergebnis im Dossier',
  props<{ next: string }>()
);

export const submitSubstance = createAction(
  '[Dossier] Submit substance'
);

export const submitSubstanceSuccess = createAction(
  '[Dossier] Submit substance (Success)'
);

export const submitSubstanceError = createAction(
  '[Dossier] Submit substance (Error)'
);

export const setCopySachverhalteDialogLoading = createAction(
  '[Dossier] Set Copy-Sachverhalte Loading',
  props<{ isLoading: boolean }>()
);

export const showCopySachverhalteDialog = createAction(
  '[Dossier] Show Copy-Sachverhalte Dialog'
);

export const setThesaurusMode = createAction(
  '[Dossier] Set thesaurus mode (none / original / recalculated)',
  props<{ thesaurusMode: ThesaurusMode }>()
);

export const showSachverhaltToggle = createAction(
  '[Dossier] Show Sachverhalt Toggle',
  props<{ mode: 'feedback' | 'copy' }>()
);

export const hideSachverhaltToggle = createAction(
  '[Dossier] Hide Sachverhalt Toggle'
);

export const sachverhaltSelected = createAction(
  '[Dossier] Sachverhalt Selected',
  props<{ sachverhaltId: number; erfassungSachverhaltId: number; merkmalName: string; merkmalId: number }>()
);

export const addSachverhaltToSelection = createAction(
  '[Dossier] Add Sachverhalt To Selection',
  props<{ sachverhaltId: number; erfassungSachverhaltId: number; merkmalName: string; merkmalId: number }>()
);

export const removeSachverhaltFromSelection = createAction(
  '[Dossier] Remove Sachverhalt From Selection',
  props<{ sachverhaltId: number; erfassungSachverhaltId: number }>()
);

// View Settings Dialog Actions
export const openViewSettingsDialog = createAction(
  '[Dossier] Open View Settings Dialog'
);

export const closeViewSettingsDialog = createAction(
  '[Dossier] Close View Settings Dialog'
);

export const openDeleteViewConfirmDialog = createAction(
  '[Dossier] Open Delete View Confirmation Dialog',
  props<{ viewName: string }>()
);

export const confirmDeleteView = createAction(
  '[Dossier] Confirm Delete View',
  props<{ viewName: string }>()
);

export const cancelDeleteView = createAction(
  '[Dossier] Cancel Delete View'
);

// Request for Approval Actions
export const loadAssignableUsers = createAction(
  '[Dossier] Load Assignable Users',
  props<{ erfassungId?: number | undefined }>()
);

export const loadAssignableUsersSuccess = createAction(
  '[Dossier] Load Assignable Users Success',
  props<{ users: UserItem[] }>()
);

export const loadAssignableUsersError = createAction(
  '[Dossier] Load Assignable Users Error',
  props<{ error: string }>()
);
